var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-pos-incident-table',{attrs:{"title":_vm.$t('global.models.pos-incident.heading'),"subtitle":_vm.$t('global.models.pos-incident.subheading'),"form-config-name":'default',"edit-form-config-name":'edit'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }